import { render, staticRenderFns } from "./changeform.vue?vue&type=template&id=915772fe&scoped=true&"
import script from "./changeform.vue?vue&type=script&lang=js&"
export * from "./changeform.vue?vue&type=script&lang=js&"
import style0 from "./changeform.vue?vue&type=style&index=0&id=915772fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915772fe",
  null
  
)

export default component.exports